<template>
  <div class="page-404">
    <img class="page-404__icon" src="@/assets/icons/404.svg" alt="" />
    <div class="page-404__message"><QuizTitle :title="message" /></div>
  </div>
</template>

<script>
import QuizTitle from "@/components/QuizTitle";

export default {
  name: "Page404",
  components: {
    QuizTitle
  },
  data() {
    return {
      message: "Dėja, toks adresas neegzistuoja."
    };
  }
};
</script>

<style lang="scss" scoped>
.page-404 {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  padding: spacer("l");

  &__icon {
    max-width: 100%;
  }
}
</style>
